module.exports = __webpack_public_path__ + "0ffa6ddcadfedaffccfce459b67b9104.png";